import React from "react";
import { MenuItem } from "../../menu-item";
import PlusIcon from "../../../../../assets/icons/Plusicon";
import MinusIcon from "../../../../../assets/icons/Minusicon";

import "./top-bar.m.css";

export const MobileMenuItem = ({
  item,
  expandedItems,
  toggleMenuItem,
  parentKey = "",
  onLinkClick,
  level = 0, // Add level, default to 0 for top level
  allSiblingKeys = []
}) => {
  const keyName = parentKey ? `${parentKey}-${item.title}` : item.title;

  const childKeys = item.children?.map(child => parentKey ? `${parentKey}-${item.title}-${child.title}` : `${item.title}-${child.title}`) || [];

  const submenuContent =
    expandedItems[keyName] && item.children?.length > 0 && (
      <div styleName={level === 1 ? "mobile-nested-submenu" : "mobile-submenu"}>
        {item.children.map((child) => (
          <MobileMenuItem
            key={child.title}
            item={child}
            expandedItems={expandedItems}
            toggleMenuItem={toggleMenuItem}
            parentKey={keyName}
            onLinkClick={onLinkClick}
            level={level + 1} // Increment level
            allSiblingKeys={childKeys}
          />
        ))}
      </div>
    );

  let menuStyleClass = "mobile-submenu-link";
  if (level >= 2) menuStyleClass = "mobile-nested-link";

  const isExpanded = expandedItems[keyName];

  return (
    <div styleName={`${level === 1 ? "mobile-nested-item" : "mobile-menu-item"} ${isExpanded ? 'expanded' : ''}`.trim()}>
      {item.children?.length > 0 ? (
        <>
          <button
            styleName={level === 1 ? "mobile-submenu-toggle" : "mobile-menu-toggle"}
            onClick={() => toggleMenuItem(keyName, allSiblingKeys)}
            aria-expanded={expandedItems[keyName] || false}
          >
            <span>{item.title}</span>
            <span styleName="toggle-icon">
              {expandedItems[keyName] ? <MinusIcon /> : <PlusIcon />}
            </span>
          </button>
          {submenuContent}
        </>
      ) : (
        <div
          styleName={level === 1 ? "mobile-nested-item" : "mobile-menu-item"} // Use mobile-menu-item for level 0 no children
        >
          <div styleName={level === 0 ? "mobile-menu-toggle" : menuStyleClass}>
            <MenuItem
              item={item}
              menuStyle={menuStyleClass}
              toggleHandler={onLinkClick}
            />
          </div>
        </div>
      )}
    </div>
  );
}

